module.exports = __webpack_public_path__ + "img/iconos_footer.0e5aa2f2.svg";